<section id="home1" class="slider-style1 border-none">
    <div class="owl-slider-full owl-carousel light-pagination owl-without-next-pre-arrow">
        <!-- slider item -->
        <div class="item owl-bg-img cover-background" style="background:url('assets/image/banner1.jpg')">
            <div class="opacity-full bg-black-dark-rgba"></div>
            <div class="container fullscreen position-relative">
                <div class="col-md-12 col-sm-12 col-12 slider-typography text-left">
                    <div class="slider-text-middle-main">
                        <div class="slider-text-middle">
                            <div class="col-md-12 col-sm-12 col-12 no-padding alt-font slider-content sm-no-margin-top">
                                <div class="col-md-6 no-padding">
                                    <div
                                        class="title-extra-large-2 line-height-60 font-weight-600 text-white slider-title margin-seven-bottom">
                                        SOLUCIONES EN COMUNICACIÓN VISUAL </div>
                                    <div class="bg-servios separator-line2 no-margin-lr sm-no-margin-bottom"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end slider item -->

        <div class="item owl-bg-img cover-background" style="background:url('assets/image/banner2.jpg')">
            <div class="opacity-full bg-black-dark-rgba"></div>
            <div class="container fullscreen position-relative">
                <div class="col-md-12 col-sm-12 col-12 slider-typography text-left">
                    <div class="slider-text-middle-main">
                        <div class="slider-text-middle">
                            <div class="col-md-12 col-sm-12 col-12 no-padding alt-font slider-content sm-no-margin-top">
                                <div class="col-md-6 no-padding">
                                    <div
                                        class="title-extra-large-2 line-height-60 font-weight-600 text-white slider-title margin-seven-bottom">
                                        CUIDAMOS DE TODOS</div>
                                    <div class="bg-fast-blue separator-line2 no-margin-lr sm-no-margin-bottom"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- slider item -->
        <div class="item owl-bg-img cover-background" style="background:url('assets/image/banner4.jpg')">
            <div class="opacity-full bg-black-dark-rgba"></div>
            <div class="container fullscreen position-relative">
                <div class="col-md-12 col-sm-12 col-12 slider-typography text-left">
                    <div class="slider-text-middle-main">
                        <div class="slider-text-middle">
                            <div class="col-md-12 col-sm-12 col-12 no-padding alt-font slider-content sm-no-margin-top">
                                <div class="col-md-6 no-padding">
                                    <div
                                        class="title-extra-large-2 line-height-60 font-weight-600 text-white slider-title margin-seven-bottom">
                                        OFRECEMOS SERVICIOS DE CALIDAD</div>
                                    <div class="bg-fast-blue separator-line2 no-margin-lr sm-no-margin-bottom"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end slider item -->
        <!-- slider item -->
        <div class="item owl-bg-img cover-background" style="background:url('assets/image/banner3.jpg')">
            <div class="opacity-full bg-black-dark-rgba"></div>
            <div class="container fullscreen position-relative">
                <div class="col-md-12 col-sm-12 col-12 slider-typography text-left">
                    <div class="slider-text-middle-main">
                        <div class="slider-text-middle">
                            <div class="col-md-12 col-sm-12 col-12 no-padding alt-font slider-content sm-no-margin-top">
                                <div class="col-md-6 no-padding">
                                    <div
                                        class="title-extra-large-2 line-height-60 font-weight-600 text-white slider-title margin-seven-bottom">
                                        GENERAMOS IMPACTO</div>
                                    <div class="bg-fast-blue separator-line2 no-margin-lr sm-no-margin-bottom"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end slider item -->
    </div>
</section>